import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  version: "1.1",
  id: "__Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  width: "45px",
  height: "45px",
  viewBox: "0 0 45 45",
  style: {"enable-background":"new 0 0 45 45"},
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), { type: "text/css" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode(".__st0{fill:none}.__st1{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10}.__st2{fill:#231F20}.__st3{fill:#121319}")
      ])),
      _: 1
    })),
    _cache[1] || (_cache[1] = _createStaticVNode("<g id=\"__Group_1757_2_\" transform=\"translate(15150.842 -247)\"><g id=\"__Group_1725_2_\" transform=\"translate(-13934.786 157.475)\"><path d=\"M-1201.81,112.55c-3,0-6.58-1.71-6.58-9.86v-1h13.17v1C-1195.22,110.84-1198.8,112.55-1201.81,112.55z M-1206.37,103.7\r\n\t\t\tc0.19,4.55,1.72,6.86,4.56,6.86s4.37-2.31,4.56-6.86H-1206.37z\"></path><g id=\"__Group_1724_2_\"><rect x=\"-1200.29\" y=\"98.97\" width=\"2\" height=\"3.5\"></rect><rect x=\"-1205.32\" y=\"98.97\" width=\"2\" height=\"3.5\"></rect></g><path d=\"M-1189.68,130.52h-7.87c-2.87,0-5.21-2.34-5.21-5.21v-14.03h2v14.03c0,1.77,1.44,3.21,3.21,3.21h7.87\r\n\t\t\tc1.77,0,3.21-1.44,3.21-3.21v-6.65h2v6.65C-1184.47,128.19-1186.81,130.52-1189.68,130.52z\"></path><path d=\"M-1178.72,119.67h-13.31V93.52h13.31V119.67z M-1190.03,117.67h9.31V95.52h-9.31V117.67z\"></path><polygon points=\"-1185.27,112.82 -1187.84,107.04 -1185.42,105.8 -1187.55,101.2 -1185.74,100.36 -1182.79,106.7 -1185.25,107.95 \r\n\t\t\t-1183.44,112.01 \t\t\"></polygon></g></g>", 1))
  ]))
}
export default { render: render }